
import {APP_ROOT} from '../../../consts'

const menuItems = [
  {
    name: 'catalog',
    label: 'Catalog',
    to: `${APP_ROOT}/`,
    icon: 'home',
    description: ''
  },
  {
    name: 'insights',
    label: 'Insights',
    to: `${APP_ROOT}/insights`,
    icon: 'users',
    description: 'List of Guides'
  },
  {
    name: 'network',
    label: 'Network',
    to: `${APP_ROOT}/network`,
    icon: 'list',
    description: 'List Resources'
  }

]

export default menuItems



// WEBPACK FOOTER //
// ./src/components/ui/AppBar/menu-items.js